import React, { useState } from 'react';

import { TCard } from '@/console/features/card-layout/card-layout.types';
import { isValidDropZone } from '@/console/features/card-layout/utils/validation';

export const useCardDrag = (cards: TCard[]) => {
  const [draggedCard, setDraggedCard] = useState<TCard | null>(null);
  const [draggedOverCard, setDraggedOverCard] = useState<TCard | null>(null);

  const resetDragStates = () => {
    setDraggedCard(null);
    setDraggedOverCard(null);
  };

  /**
   * Checks if the drag started in the card header area
   * The header area is considered the top 48px of the card
   * This allows dragging from the entire header instead of just the grip icon
   */
  const handleDragStart = (e: React.DragEvent, card: TCard) => {
    // Get pointer position relative to the card
    const target = e.currentTarget.getBoundingClientRect();
    const relativeY = e.clientY - target.top;

    // Allow dragging only from the header area (top 48px)
    if (relativeY > 48) {
      e.preventDefault();
      return;
    }

    // Set the dragged card state
    setDraggedCard(card);

    // Set drag image offset to make it visually pleasing
    if (e.dataTransfer.setDragImage && target.width) {
      const offsetX = target.width / 2;
      e.dataTransfer.setDragImage(e.currentTarget, offsetX, 24);
    }
  };

  const handleDragOverCard = (e: React.DragEvent, card: TCard) => {
    e.preventDefault();
    if (!draggedCard) return;
    if (isValidDropZone(draggedCard.id, card.position.slot, cards)) {
      setDraggedOverCard(card);
    }
  };

  return {
    draggedCard,
    draggedOverCard,
    resetDragStates,
    handleDragStart,
    handleDragOverCard,
  };
};
